module.exports = __webpack_public_path__ + "static/media/megastar.f3bae16d.svg";